import { useState } from 'react';
import { exportCSV, exportAnki, removeWord } from '../utils/wordlist';
import { toRomaji } from 'wanakana';
import FlashcardReview from './FlashcardReview';

export default function WordListPanel({ words, onUpdate, onClose }) {
  const [reviewing, setReviewing] = useState(false);

  function handleRemove(word) {
    onUpdate(removeWord(words, word));
  }

  return (
    <>
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, zIndex: 1100, background: 'rgba(0,0,0,0.18)' }}
      />
      <div style={{
        position: 'fixed', top: 0, right: 0, bottom: 0, zIndex: 1200,
        width: 'min(360px, 100vw)', background: '#faf9f6',
        borderLeft: '1px solid #e8e6e1',
        boxShadow: '-8px 0 32px rgba(0,0,0,0.10)',
        display: 'flex', flexDirection: 'column',
      }}>
        {/* Header */}
        <div style={{
          padding: '18px 20px 14px',
          borderBottom: '1px solid #e8e6e1',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <span style={{ fontWeight: 700, fontSize: 16 }}>
            Word List <span style={{ color: '#aaa', fontWeight: 400, fontSize: 14 }}>({words.length})</span>
          </span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#bbb', fontSize: 18, padding: '10px', margin: '-10px' }}>✕</button>
        </div>

        {/* Action buttons */}
        {words.length > 0 && (
          <div style={{ padding: '12px 20px', borderBottom: '1px solid #e8e6e1', display: 'flex', gap: 8 }}>
            <button onClick={() => setReviewing(true)} style={btnStyle('#4a90d9')}>Review</button>
            <button onClick={() => exportCSV(words)} style={btnStyle('#555')}>CSV</button>
            <button onClick={() => exportAnki(words)} style={btnStyle('#7c5cbc')}>Anki</button>
          </div>
        )}

        {/* Word list */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
          {words.length === 0 ? (
            <p style={{ color: '#bbb', fontSize: 14, textAlign: 'center', marginTop: 48, fontStyle: 'italic' }}>
              No words saved yet.<br />Click a word, then press Save.
            </p>
          ) : (
            words.map(w => (
              <div key={w.word} style={{ padding: '12px 20px', borderBottom: '1px solid #f0ede8' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 22, fontWeight: 700, fontFamily: '"Hiragino Mincho ProN", serif' }}>{w.word}</span>
                      {w.reading && (
                        <span style={{ fontSize: 12, color: '#888' }}>
                          {w.reading} · {toRomaji(w.reading)}
                        </span>
                      )}
                      {w.jlpt && <span style={jlptBadge(w.jlpt)}>{w.jlpt}</span>}
                    </div>
                    {w.pos && (
                      <div style={{ fontSize: 10, color: '#aaa', textTransform: 'uppercase', letterSpacing: 1, margin: '3px 0 4px' }}>{w.pos}</div>
                    )}
                    <div style={{ fontSize: 13, color: '#555', lineHeight: 1.5 }}>
                      {w.definitions.slice(0, 2).join(' / ')}
                    </div>
                    {w.sentence && (
                      <div style={{
                        marginTop: 7, fontSize: 12, color: '#999', lineHeight: 1.7,
                        fontFamily: '"Hiragino Mincho ProN", serif',
                        display: '-webkit-box', WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical', overflow: 'hidden',
                      }}>
                        {w.sentence}
                      </div>
                    )}
                  </div>
                  <button
                    onClick={() => handleRemove(w.word)}
                    title="Remove"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: 16, flexShrink: 0, padding: '10px', margin: '-10px' }}
                  >✕</button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {reviewing && <FlashcardReview words={words} onClose={() => setReviewing(false)} />}
    </>
  );
}

function btnStyle(color) {
  return {
    flex: 1, padding: '7px 0', fontSize: 13, fontWeight: 600,
    background: color, color: 'white', border: 'none', borderRadius: 8,
    cursor: 'pointer',
  };
}

function jlptBadge(jlpt) {
  const colors = { N5: '#4caf50', N4: '#8bc34a', N3: '#ff9800', N2: '#ff5722', N1: '#e53935' };
  return {
    fontSize: 10, fontWeight: 700, padding: '2px 6px', borderRadius: 4,
    background: colors[jlpt] || '#999', color: 'white', letterSpacing: 0.5,
  };
}
